import apiClient from './apiClient';

export interface F11G {
  f11g_01: string; f11g_11: string; f11g_12: string;
  f11g_91: string; f11g_92: string | null; f11g_93: string;
}
export interface ListResponse { data: F11G[]; total: number; page: number; size: number; }

export const inspMethodApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/insp-method', { params })).data;
  },
  async get(code: string): Promise<F11G> {
    return (await apiClient.get(`/api/insp-method/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { f11g_01: string; f11g_11: string; f11g_12: string }): Promise<F11G> {
    return (await apiClient.post('/api/insp-method', data)).data;
  },
  async update(code: string, data: { f11g_11: string; f11g_12: string }): Promise<F11G> {
    return (await apiClient.put(`/api/insp-method/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/insp-method/${encodeURIComponent(code)}`);
  },
};
